<div class="page-body">
  <div *ngIf="loading">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div
    *ngIf="!loading && !authInProgress && !authComplete"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <div *ngIf="getIsPaymentMethodMatching('INVOICE')" class="page-icon">
        <app-zaver-icon [size]="80" name="invoiceCircle"></app-zaver-icon>
      </div>
      <div
        *ngIf="
          getIsPaymentMethodMatching('CREDIT') ||
          getIsPaymentMethodMatching('CREDIT_DIRECT_DEBIT')
        "
        class="page-icon"
      >
        <app-zaver-icon [size]="80" name="cakeCircle"></app-zaver-icon>
      </div>

      <div *ngIf="getIsPaymentMethodMatching('INVOICE')" class="page-text">
        {{ translations.invoiceTitle }}
      </div>
      <div
        *ngIf="
          getIsPaymentMethodMatching('CREDIT') ||
          getIsPaymentMethodMatching('CREDIT_DIRECT_DEBIT')
        "
        class="page-text"
      >
        {{ getInstallmentsTitle() }}
      </div>

      <div class="details-table">
        <hr class="details-divider" />
        <div class="details-container">
          <div class="details-key-entry">
            {{ state.paymentInformation.title }}
          </div>

          <zaver-button-link
            [text]="translations.purchaseDetails"
            (click)="toggleModalSelectDetailsTab()"
          >
          </zaver-button-link>
        </div>

        <hr class="details-divider" />
        <div class="details-container">
          <div class="details-key-entry">{{ translations.termsTitle }}</div>

          <zaver-button-link
            (click)="toggleModalSelectTermsTab()"
            [text]="translations.termsView"
          >
          </zaver-button-link>
        </div>

        <hr class="details-divider" />
        <div class="details-container">
          <div class="details-key-entry">{{ translations.totalAmount }}</div>

          <div class="details-value-entry">
            {{ state.totalCheckoutValue | value }}
          </div>
        </div>

        <hr class="details-divider" />
      </div>

      <zaver-primary-button
        [text]="translations.confirmButton"
        (click)="handleCtaClick()"
      ></zaver-primary-button>

      <p class="legal-confirmation-text">
        {{ translations.legalConfirmation }}
      </p>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  logo="assets/img/Zaver_Logotype_Circle_Coal_DE.svg"
  [buttonText]="translations.closeButton"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectedItem]="selectedItem"
    [selectorItems]="selectorItems"
  ></app-selector>
</zaver-checkout-modal>
